<template>
  <div>
    <span
      class="accountbox logged"
      v-if="!_.isEmpty(userInfo) && userInfo.token"
    >
      <Dropdown @on-click="dropdownHandle">
        <a href="javascript:void(0)" class="userinfo" @click.stop.prevent>
          <img
            :src="
              userInfo.portrait
                ? userInfo.portrait
                : userInfo.gender === 1
                ? defaultAvatar2
                : defaultAvatar
            "
            :onerror="
              `this.src='${
                userInfo.gender === 1 ? defaultAvatar2 : defaultAvatar
              }'`
            "
            class="avatar"
            v-if="userInfo.name"
          />
          <span>{{ userInfo.name | truncate(10) }}</span>
          <Icon type="arrow-down-b"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem name="changePwd"
            ><span style="color: #fff !important;">{{ $t("common.cpwd") }}</span></DropdownItem
          >
          <DropdownItem divided name="logout"
            ><span style="color: #fff !important;">{{ $t("common.logout") }}</span></DropdownItem
          >
        </DropdownMenu>
      </Dropdown>
    </span>
    <!-- <div class="new-header-right">
      <span>
        <img src="~@/assets/images/homeNew/u162.png" class="lau-img" />
      </span>

      <span>| </span>
      <span>
        <a
          href="/login"
          style="line-height: 20px;color:#fff"
          :class="$style.account"
          v-if="_.isEmpty(userInfo)"
        >
          <span style="color:#fff;font-size: 14px;"> 登录 </span>
        </a>
      </span>
      <span>| </span>
      <span>
        <a
          href="/login"
          style="line-height: 20px;color:#fff"
          :class="$style.account"
          v-if="_.isEmpty(userInfo)"
        >
          <span style="color:#fff;font-size: 14px;">注册 </span>
        </a>
      </span>
    </div> -->
    <span>
      <a
        href="/login"
        style="line-height: 60px;color:#fff"
        :class="$style.account"
        v-if="_.isEmpty(userInfo)"
      >
        <span style="color:#fff;font-size: 14px;"> 登录 </span>
      </a>
    </span>
  </div>
</template>

<script>
import { mapMutations, createNamespacedHelpers } from "vuex";
import defaultAvatar from "@/assets/images/default_avatar.png";
import defaultAvatar2 from "@/assets/images/default_avatar2.png";
const { mapState: mapAccountState } = createNamespacedHelpers("account");

export default {
  name: "Account",
  data() {
    return {
      isSubmit: false,
      defaultAvatar: defaultAvatar,
      defaultAvatar2: defaultAvatar2
    };
  },
  computed: {
    ...mapAccountState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    accoutClear() {
      this.setUserInfo();
      this.isSubmit = false;
      this.$Loading.finish();
      this.$router.push({ path: "/login" });
    },
    logout() {
      if (!this.isSubmit) {
        this.$Loading.start();
        this.isSubmit = true;
        this.$api.account.logout({
          success: response => {
            this.accoutClear();
          },
          error: errorMsg => {
            this.accoutClear();
          }
        });
      }
    },
    dropdownHandle(name) {
      switch (name) {
        case "changePwd":
          this.setChkPwdModalState(true);
          break;
        case "myAccount":
          this.$router.push({ name: "myAccount" });
          break;
        case "settings":
          this.setSettingModalState(true);
          break;
        case "myProfile":
          this.setEditProfileModalState(true);
          break;
        default:
          this.logout();
      }
    },
    ...mapMutations({
      isShow: "account/setModalState",
      setChkPwdModalState: "account/setChkPwdModalState",
      setSettingModalState: "account/setSettingModalState",
      setEditProfileModalState: "account/setEditProfileModalState",
      setUserInfo: "account/setUserInfo"
    })
  }
};
</script>
<style scoped>
.icon2 {
  /* background: url("~@/assets/images/icons/account_2.png") 0 center no-repeat transparent;
    background-size: 9px; */
} 
.icon2 span{
  color: #333   !important;
}
.icon2 .userinfo {
  color: #333;
}
.icon3 .svg-icon {
  color: #333;
  font-size: 1.8rem;
  margin-right: 3px;
}
.icon2 .svg-icon {
  color: #333;
  font-size: 1.8rem;
  margin-right: 3px;
}
.accountbox.logged {
  background: none;
  position: relative;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}
.accountbox.logged .ivu-icon-person {
  background: url("~@/assets/images/icons/account.png") 0 1px no-repeat
    transparent;
  background-size: 9px;
  width: 10px;
  height: 12px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.accountbox.logged.icon2 .ivu-icon-person {
  background-image: url("~@/assets/images/icons/account_2.png");
}
.accountbox.logged .ivu-icon-person:before {
  content: none;
}
.accountbox.logged .userinfo {
  color: #fff;
  font-size: 12x;
  position: relative;
  padding-left: 33px;
  line-height: 60px;
}
.icon2 .userinfo {
  color: #333 !important;
}
.accountbox.logged .userinfo .avatar {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  position: absolute;
  top: 36%;
  left: 0;
  transform: translateY(-50%);
}
.accountbox.logged .userinfo .vip-icon {
  display: inline-block;
  padding-left: 2px;
  position: relative;
  top: 1px;
}
.accountbox.logged .userinfo .ivu-icon-arrow-down-b {
  color: #333;
  font-size: 12px;
  position: relative;
  top: -2px;
  transition: all 0.3s;
}
.accountbox.logged .userinfo:hover >>> .ivu-icon-arrow-down-b {
  transform: rotate(180deg);
}
.accountbox.logged.icon2 .userinfo .ivu-icon-arrow-down-b {
  color: #666;
}
>>> .ivu-select-dropdown {
  width: inherit;
  max-height: 200px;
  overflow: auto;
  margin: 0px 0;
  padding: 5px 0;
  background-color: #333;
  box-sizing: border-box;
  border-radius: 0px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 900;
}
>>> .ivu-select-dropdown {
  background-color: rgb(6, 55, 121) !important;
}
>>> .ivu-dropdown-item {
  color: #333 !important;
}
>>> .ivu-dropdown-item-focus,
.ivu-dropdown-item:hover {
  background: transparent;
}
>>> .ivu-dropdown-item-divided:before {
  content: "";
  height: 0px;
  display: block;
  margin: 0 -16px;
  background-color: #333;
  position: relative;
  top: -7px;
}
.accountbox >>> .ivu-select-dropdown {
  border-radius: 2px;

  min-width: 142px;
  margin: 15px 2px;
  padding: 6px 0 12px;
  z-index: 1111;
  color: #333;
}
.accountbox >>> .ivu-select-dropdown .ivu-dropdown-item span {
  font-size: 15px;
  color: #fff;
}
.userinfo:hover {
  text-decoration: none;
  box-shadow: none;
}
.userinfo:after {
  content: none;
  width: 0;
  height: 0;
}
</style>
<style module>
.account {
  /* background: url("@/assets/images/icons/account.png") 0 center no-repeat transparent;
    background-size: 9px;
    padding-left: 16px; */
}
</style>
<!-- <style scoped>
.lau-img {
  height: 20px;
  width: auto;
}
.new-header-right {
  display: flex;
  float: right;
}
.new-header-right span {
  padding-right: 10px;
  line-height: 20px;
}
</style> -->



// WEBPACK FOOTER //
// src/components/layout/Account.vue